import { render, staticRenderFns } from "./DebtRestructuringInfo.vue?vue&type=template&id=72b768d0&"
import script from "./DebtRestructuringInfo.vue?vue&type=script&lang=js&"
export * from "./DebtRestructuringInfo.vue?vue&type=script&lang=js&"
import style0 from "./DebtRestructuringInfo.vue?vue&type=style&index=0&id=72b768d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports